(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('BrickOsfe', BrickOsfe);

    BrickOsfe.$inject = ['$resource'];

    function BrickOsfe ($resource) {
        var resourceUrl =  'api/brick-osfes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
